import { request } from '@/api/apiUtils';
import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { ISnapshot, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const SNAPSHOTS_ROOT = ['snapshots'] as const;

interface SnapshotsListParams {
    projectId: number;
}

const fetchers = {
    list: {
        key: ({ projectId }: SnapshotsListParams) => [...SNAPSHOTS_ROOT, 'list', projectId] as const,
        fetch: async ({ projectId }: SnapshotsListParams): Promise<ISnapshot[]> => {
            const response: ResponseType<ISnapshot[]> = await request(`versions/${projectId}`);
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const snapshotsEntity: EntityDefinition<typeof fetchers> = {
    name: 'snapshots',
    roots: [SNAPSHOTS_ROOT],
    fetchers,
};

export const useSnapshotsList = createEntityQuery(snapshotsEntity, 'list');

export type { SnapshotsListParams };
